export const SET_SETTINGS = "[settings] Set settings";
export const RESET_SETTINGS = "[settings] Reset settings";
export const UPDATE_SETTINGS = "[settings] Update settings";
export const TOGGLE_SIDEBAR = "[User] Toggle navbar";
export const RESET_SIDEBAR = "[User] Reset navbar";
